<template>
  <div  body  v-loading="tableLoading">
    <!-- 配置中心 -->
    <!-- 判断有没有选项卡 -->
    <el-tabs type="border-card" class="demo-tabs">
      <el-tab-pane v-for="(item, index) in tabList" :key="index">
        <template #label>
          <span class="custom-tabs-label">
            <el-tooltip
              v-if="item.comment"
              effect="light"
              placement="bottom"
              :content="item.namespaceName"
            >
              <span>{{ item.comment }}</span>
            </el-tooltip>
            <span v-else>{{ item.namespaceName }}</span>
          </span>
        </template>
        <ConfigServerData
          :tableLoading="tableLoading"
          @update-list="updateList"
          :namespaceName="item.namespaceName"
          :tableMaxHeight="700"
          :datas="item.items"
        ></ConfigServerData>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { GetConfigServer } from "../../network/configServer";
import { isNull } from "../../common/utils";
import ConfigServerData from "../configServer/ConfigServerData.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs, onMounted, getCurrentInstance } from "vue";

export default {
  name: "ConfigServer",
  components: {
    ConfigServerData,
  },
  setup() {
    const data = reactive({
      tabList: [],
      activeName: 0,
      tableLoading: false,
    });
    onMounted(() => {
      getData();
    });
    let { ctx: that, proxy } = getCurrentInstance();
    const getData = async () => {
      data.tableLoading = true;
      const res = await GetConfigServer();
      data.tableLoading = false;
      console.log(res);
      if (res.code == 0) {
        ElMessage.error(res.message);
        return;
      }
      if (
        !isNull(res.result) &&
        Object.prototype.toString.call(res.result) == "[object Array]" &&
        res.result.length > 0
      ) {
        data.tabList = res.result;
        proxy.$forceUpdate();
      }
    };

    const updateList = () => {
      getData();
    };
    return {
      ...toRefs(data),
      getData,
      updateList,
    };
  },
};
</script>

<style scoped>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
.demo-tabs .custom-tabs-label .el-icon {
  vertical-align: middle;
}
.demo-tabs .custom-tabs-label span {
  vertical-align: middle;
  margin-left: 4px;
}
</style>